import { FormattedMessage, useIntl } from "react-intl";

import { CtaModal } from "ui/CtaModal";
import { ClipIcon } from "ui/Icons/Icons";
import { BodyM } from "ui/Typography/Typography";

import { useInboundStore } from "../stores/inboundStore/useInboundStore";
import { useFetchClaimedProducts } from "../stores/useInboundDropService";

export function NewProductsModalModal() {
  const intl = useIntl();
  const setInboundUIState = useInboundStore((state) => state.setInboundUIState);
  const { fetchClaimedProducts } = useFetchClaimedProducts();
  const handleOnclick = async () => {
    await fetchClaimedProducts();
    setInboundUIState({ isNewProductsModalVisible: false });
  };
  return (
    <CtaModal
      isOpen
      onClose={() => {}}
      hideCloseButton
      onClickCta={handleOnclick}
      headerIcon={<ClipIcon boxSize="80px" />}
      title={intl.formatMessage({ id: "components.new-products-modal.title" })}
      body={
        <BodyM textAlign="center">
          <FormattedMessage id="components.new-products-modal.description" />
        </BodyM>
      }
      ctaLabel={intl.formatMessage({ id: "generic.actions.refresh-page" })}
    />
  );
}
